import { makeStyles } from 'tss-react/mui';

const useStylesActionButton: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  actionButton: {
    width: 'auto',
    height: 'auto',
    '& > svg': {
      verticalAlign: 'middle',
    },
  },
  actionButtonFixedSize: {
    width: '40px !important',
    height: '40px !important',
  },
  actionButtonInline: {
    display: 'inline-flex !important',
  },
  actionButtonHidden: {
    visibility: 'hidden',
  },
  actionButtonRight: {
    margin: '0 0 0 auto',
  },
  actionButtonOffset: {
    marginLeft: '10px !important',
  },
  actionButtonNoPadding: {
    padding: '0 !important',
  },
  actionButtonNoHighlight: {
    '&:hover': {
      background: 'none !important',
    },
  },
  actionButtonSmallPadding: {
    padding: '5px !important',
    marginRight: '5px !important',
  },
  actionButtonLight: {
    color: `${theme.palette.common.white} !important`,
    '& > svg': {
      color: `${theme.palette.common.white} !important`,
    },
  },
  actionButtonLightDisabled: {
    color: theme.palette.common.black,
    '& > svg': {
      color: `${theme.palette.common.black} !important`,
    },
  },
  actionButtonControl: {
    '& > svg': {
      verticalAlign: 'initial !important',
    },
  },
}));

export default useStylesActionButton;
